import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Mechanism } from './components/Mechanism';
import { Authority } from './components/Authority';
import { Testimonials } from './components/Testimonials';
import { ValueStack } from './components/ValueStack';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-dark pt-10 md:pt-12" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Mechanism data-id="element-4" />
        <Authority data-id="element-5" />
        <Testimonials data-id="element-6" />
        <ValueStack data-id="element-7" />
        <FAQ data-id="element-8" />
        <Guarantee data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}